import { BadgeCheck } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { Logo } from "./Logo";

const PORTRAIT =
  "https://images.unsplash.com/photo-1465776702172-defce4b4d574?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHw0fHxibGFjayUyMGhhbmRzJTIwc2lnbmluZyUyMGRvY3VtZW50JTIwbHV4dXJ5JTIwd2FybSUyMGxpZ2h0fGVufDB8fHx8MTc5MDg3NTA1MHww&ixlib=rb-4.1.0&q=85";

const CREDENTIALS = [
  "Licensed in Property & Casualty",
  "Life & Health coverage specialist",
  "Georgia Medicaid enrollment guidance",
];

export const About = () => (
  <section id="about" data-testid="about-section" className="relative py-24 sm:py-32 lg:py-36">
    <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-16 px-4 sm:px-8 lg:grid-cols-12 lg:px-12">
      <Reveal className="lg:col-span-5">
        <div className="relative mx-auto max-w-md">
          <div className="absolute -right-6 -top-6 opacity-40">
            <div className="animate-[spin_30s_linear_infinite]">
              <Logo size={110} testId="about-star" />
            </div>
          </div>
          <div
            data-testid="about-portrait-frame"
            className="relative overflow-hidden rounded-[2rem] border border-[color:var(--ns-line)] shadow-2xl shadow-black/40"
          >
            <img
              src={PORTRAIT}
              alt="Reviewing Hunt Shield Insurance policy documents at a desk"
              className="aspect-[4/5] w-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0B0F17]/60 via-transparent to-transparent" />
            <div className="absolute bottom-5 left-5 rounded-full border border-white/10 bg-[#0B0F17]/70 px-4 py-2 backdrop-blur-md">
              <p className="font-mono text-xs tracking-[0.2em] text-amber-200/90">EST. ATLANTA, GA</p>
            </div>
          </div>
        </div>
      </Reveal>

      <Reveal className="lg:col-span-7" delay={0.1}>
        <Eyebrow testId="about-eyebrow">Meet your agent</Eyebrow>
        <h2
          data-testid="about-heading"
          className="font-serif text-2xl tracking-tight text-[color:var(--ns-ink)] sm:text-3xl lg:text-4xl"
        >
          Renee Black — <em className="text-[color:var(--ns-gold)]">a steady hand</em> in a
          complicated industry.
        </h2>
        <p className="mt-6 max-w-2xl text-base leading-relaxed text-[color:var(--ns-muted)] sm:text-lg">
          Insurance is full of jargon, pressure, and 1-800 numbers. Renee started Hunt Shield
          Insurance Group to be the opposite: one trusted person who knows your name, explains
          your options plainly, and shops the market on your behalf — across home, auto, life,
          health, and Medicaid.
        </p>
        <ul className="mt-8 space-y-3.5">
          {CREDENTIALS.map((c) => (
            <li key={c} className="flex items-center gap-3 text-[color:var(--ns-ink)]">
              <BadgeCheck size={18} className="shrink-0 text-[color:var(--ns-gold)]" />
              <span className="text-sm sm:text-base">{c}</span>
            </li>
          ))}
        </ul>
        <blockquote
          data-testid="about-guarantee"
          className="mt-10 border-l-2 border-[color:var(--ns-gold)] pl-6 font-serif text-lg italic leading-relaxed text-[color:var(--ns-ink)]/90 sm:text-xl"
        >
          "If I wouldn't sell it to my own family, I won't sell it to yours. That's the whole
          business model."
          <footer className="mt-3 font-mono text-xs uppercase tracking-[0.25em] text-[color:var(--ns-gold)]">
            — Renee Black, Founder
          </footer>
        </blockquote>
      </Reveal>
    </div>
  </section>
);
